import React from "react";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import "./VisionMission.css"; // Custom CSS for additional styling

const VisionMission = () => {
  return (
    <div className="container-fluid d-flex flex-column align-items-center justify-content-center text-white bg-black py-5">
      {/* Section Title */}
      <motion.h1
        className="text-center fw-bold mb-5"
        style={{ color: "#FFCCCC", borderBottom: "3px solid #FFCCCC", display: "inline-block", paddingBottom: "5px" }}
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        Vision & Mission
      </motion.h1>

      <div className="row w-100 justify-content-center">
        {/* Vision Section */}
        <motion.div
          className="col-12 col-lg-6 d-flex justify-content-center mb-4 px-3"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <div className="card text-white p-5 shadow-lg" style={{ backgroundColor: "#000", borderRadius: "12px", border: "2px solid #FFCCCC", maxWidth: "500px" }}>
            <h2 className="text-center fw-bold mb-3" style={{ color: "#FFCCCC" }}>Our Vision</h2>
            <p className="text-center fst-italic">
              To empower students to achieve academic excellence and personal growth, fostering a community of lifelong learners who contribute positively to society.
            </p>
          </div>
        </motion.div>

        {/* Mission Section */}
        <motion.div
          className="col-12 col-lg-6 d-flex justify-content-center px-3"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <div className="card text-white p-5 shadow-lg" style={{ backgroundColor: "#000", borderRadius: "12px", border: "2px solid #FFCCCC", maxWidth: "500px" }}>
            <h2 className="text-center fw-bold mb-3" style={{ color: "#FFCCCC" }}>Our Mission</h2>
            <p className="text-center fst-italic">
              To provide high-quality education through innovative teaching methods, personalized attention, and a supportive learning environment, preparing students to excel in their chosen fields.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default VisionMission;
